
export default class EmailTemplatesController {

	constructor ($state, $filter, emailTemplates, EmailTemplate, zones) {
		var translate = $filter('translate');
		var buttons = [
			{ label: translate('PUBLISH'), action: this.publish.bind(this) },
			{ label: translate('EDIT'),	action: this.edit.bind(this) },
			{ label: translate('REMOVE'),  action: this.remove.bind(this) },
		];
		this.headers = [
			{ key: 'name',	   label: translate('NAME'),	type: 'text' },
			{ key: '',		   label: '',				   type: 'buttons', buttons },
		];
		this.$state = $state;
		this.translate = translate;
		this.EmailTemplate = EmailTemplate;
		this.templates = emailTemplates;
		this.zones = zones;
	}

	create () {
		swal({
			title: this.translate('ADD_TEMPLATE'),
			text: `${this.translate('ADD_TEMPLATE_NAME')}`,
			type: 'input',
			showCancelButton: true,
			// buttons: [ this.translate('CANCEL'), this.translate('ADD_TEMPLATE') ],
		}, async name => {
			if (name) {
				const emailTemplate = await this.EmailTemplate.create({ name });
				this.edit(emailTemplate);
			}
		});
	}

	publish (emailTemplate) {
		swal({
			title: this.translate('PUBLISH_TEMPLATE'),
			text: '<select'
				 +'    class="form-control"'
				 +'    style="display: block"'
				 +'    id="publish-to"'
				 +'    value="-1"'
				 +'>'
				 +'<option value="-1">' + this.translate('ALL_STORES') + '</option>'
				 +this.zones.map(z => '<option value="' + z.id + '">  - ' + this.translate('ZONE') + ' ' + z.name + '</option>').join('')
				 +'</select>',
			html: true,
			showCancelButton: true,
			closeOnConfirm: false,
		}, async (confirm) => {
			if (confirm) {
				const publishTo = document.getElementById('publish-to').value;
				const destination = publishTo == '-1' ? {} : { zoneId: +publishTo };
				await this.EmailTemplate.publish(emailTemplate.id, destination);
				return swal.close();
			}
			return true;
		});
	}

	edit (emailTemplate) {
		this.$state.go('emailTemplateFormPage', emailTemplate);
	}

	reload () {
		this.$state.go('emailTemplatesPage', {}, { reload: true });
	}

	remove (emailTemplate) {
		swal({
			title: this.translate('ARE_YOU_SURE'),
			text: `${this.translate('QUESTION_DELETE_TEMPLATE')} "${emailTemplate.name}"`,
			type: 'warning',
			showCancelButton: true
		}, confirm => confirm && this.EmailTemplate.delete(emailTemplate.id).then(this.reload.bind(this)));
	}

}

EmailTemplatesController.$inject = ['$state', '$filter', 'emailTemplates', 'EmailTemplate', 'zones'];



// WEBPACK FOOTER //
// ./src/page/emailTemplates/emailTemplates.controller.js